import { LoadingServiceT } from './common-loading.service';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingServiceT: LoadingServiceT) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    //请求拦截
    // console.log(req);
    const storedStatuses = JSON.parse(localStorage.getItem('loadingStatuses')) || {};
    let hasLoading =  storedStatuses[req.url] || false;
    
    if (hasLoading) {
      this.loadingServiceT.showLoading();
    }
    return next.handle(req).pipe(
      tap(
        //响应拦截
        (event) => {
          // console.log(event);
          if (event instanceof HttpResponse) {
            if (event.status >= 500) {
              // 跳转错误页面
            } else if (event.status == 200) {
            }
          }
        },
        (error) => {
          console.log(error);
        },
      ),
      finalize(() =>{
        if (hasLoading) {
          this.loadingServiceT.hideLoading();
          localStorage.setItem('loadingStatuses', JSON.stringify({}));
        }
      })
    );
  }
}
